// React
import React from 'react';
import config from 'config';
import Utils from '../../utils/utils';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

// Internationalization
import locationApi from '../../api/location-api'

class RouterProvider extends React.Component {
	constructor(props) {
		super(props);
		if (this.props.location){
			locationApi.setLocation(this.props.location);
		}		
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.location.pathname != nextProps.location.pathname && nextProps.location){
			
			Utils.setTemporaryClass('fade', config.application.secureTransitionPageTime, config.application.bodyContainerId);
			Utils.scrollGoToTop(nextProps.location);

			locationApi.setLocation(nextProps.location);

		}
	}

	render() {
		return (
			React.Children.only(this.props.children)
		);
	}
}

export default withRouter(connect()(RouterProvider));


// WEBPACK FOOTER //
// ./src/components/providers/routerProvider.component.jsx